<div class="product-grid-item" [attr.data-cy]="'product-grid-item-' + product.code">
  <div class="grid-item-picture">
    <a
      [routerLink]="['/' + product.fullProductPath + '/p/' + product.code] | cxUrl"
      [queryParams]="queryParams"
      class="cx-product-image-container"
      tabindex="-1"
    >
      <cx-media
        class="product-grid-item__image picture"
        [container]="product.images?.PRIMARY || product.images?.[0]"
        [alt]="product.name"
        format="product"
      ></cx-media>
    </a>
  </div>
  <a
    [routerLink]="['/' + product.fullProductPath + '/p/' + product.code] | cxUrl"
    [queryParams]="queryParams"
    class="product-grid-item__title"
    [innerHTML]="product.name"
  ></a>

  <div class="product-grid-item__summary">
    <div [innerHTML]="product.summary"></div>
  </div>
  <a
    [routerLink]="['/' + product.fullProductPath + '/p/' + product.code] | cxUrl"
    [queryParams]="queryParams"
    class="product-grid-item__show-more-wrapper"
  >
    <div class="product-grid-item__show-more">{{ 'productGridItem.viewMore' | cxTranslate }}</div>
  </a>
</div>
